import { WelcomeActionTypes } from './types';
import { action } from 'typesafe-actions';

export const verifyInviteTokenStart = (token: string) =>
  action(WelcomeActionTypes.VERIFY_INVITE_TOKEN_START, token);
export const verifyInviteTokenSuccess = () =>
  action(WelcomeActionTypes.VERIFY_INVITE_TOKEN_SUCCESS);
export const verifyInviteTokenFailure = (error: string) =>
  action(WelcomeActionTypes.VERIFY_INVITE_TOKEN_FAILURE, error);
